import { Routes } from '@angular/router';
import { isLeasingCompanyUserGuard } from '@shared/guards/leasing-company/leasing-company.guard';

export const coulanceRoutes: Routes = [
  {
    path: 'general',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/leasing-company/coulance/general/overview/overview.component'),
      },
      {
        path: 'add',
        loadComponent: () => import('@app/leasing-company/coulance/general/add/add.component'),
        canActivate: [isLeasingCompanyUserGuard({ roles: ['LEASING_COMPANY_MANAGER', 'LEASING_COMPANY_WITH_AUTHORIZATION'] })],
      },
    ],
  },
  {
    path: 'brand',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/leasing-company/coulance/brand/overview/overview.component')
      },
      {
        path: 'add',
        loadComponent: () => import('@app/leasing-company/coulance/brand/add/add.component'),
        canActivate: [isLeasingCompanyUserGuard({ roles: ['LEASING_COMPANY_MANAGER', 'LEASING_COMPANY_WITH_AUTHORIZATION'] })],
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'general',
  },
];
